<template>
  <div>
    <el-select
      :placeholder="placeholder"
      v-model="internalValue"
      @change="handleChange"
      clearable
      filterable
      remote
      :remote-method="remoteMethod"
      @clear="loadOptions(1, pageSize)"
      @visible-change="onDropdownVisible"
      popper-class="search-popover"
      style="height: 40px; margin-bottom: 8px"
    >
      <el-option
        v-for="item in options"
        :key="item[keyField]"
        :label="item[labelField]"
        :value="item[valueField]"
      >
      </el-option>
      <el-option v-if="loading" disabled value="" class="el-select-loading">
        <span class="el-select-loading__tips">加载中...</span>
      </el-option>
      <el-option
        v-else-if="!hasMore && options.length > 0"
        disabled
        value=""
        class="el-select-loading"
      >
        <span class="el-select-loading__tips">没有更多了~</span>
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { CHECKALLINDUSTRYBRAND } from '@/api/cutting'
export default {
  props: {
    //选中值
    value: {
      type: [String, Number],
      default: null
    },
    placeholder: {
      type: String,
      default: 'please select'
    },
    //异步请求
    fetchOptions: {
      type: Function,
      required: true
    },
    keyField: {
      type: String,
      default: 'id'
    },
    labelField: {
      type: String,
      default: 'name'
    },
    valueField: {
      type: String,
      default: 'id'
    },
    initialPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      internalValue: this.value,
      options: [],
      loading: false,
      hasMore: true,
      currentPage: this.initialPage,
      searchStuts: false,
      searchTimer: null,
      scrollListenerAdded: false
    }
  },
  watch: {
    value(newVal) {
      this.internalValue = newVal
    },
    internalValue(newVal) {
      this.$emit('input', newVal)
    }
  },
  mounted() {
    this.loadOptions(this.currentPage, this.pageSize)
  },
  beforeDestroy() {
    this.removeScrollListener()
  },
  methods: {
    async loadOptions(page, pageSize, query) {
      if (this.loading) return
      this.loading = true
      try {
        const res = await this.fetchOptions({ page, pageSize, query })
        console.log('🚀 ~ loadOptions ~ res:', res)
        const list = res ? res.body : []
        if (page === this.initialPage) {
          this.options = []
        }
        this.options.push(...list)
        this.hasMore = list.length > 0
        console.log('🚀 ~ loadOptions ~  this.hasMore:', this.hasMore)
        this.currentPage = page
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    onDropdownVisible(visible) {
      if (visible) {
        // 远程搜索时不做触底加载和自动填充
        if (this.searchStuts) return
        this.$nextTick(() => {
          let popperClass = this.$attrs['popper-class'] || 'search-popover'
          const dropdown = document.querySelector(
            `.${popperClass} .el-select-dropdown__wrap`
          )
          if (dropdown) {
            dropdown.addEventListener('scroll', this.handleScroll)
            this.scrollListenerAdded = true
            this.checkAndAutoLoad(dropdown)
          }
        })
      } else {
        this.removeScrollListener()
      }
    },
    checkAndAutoLoad(dropdown) {
      // 远程搜索时不做自动填充
      if (this.searchStuts) return
      if (
        dropdown &&
        dropdown.scrollHeight <= dropdown.clientHeight &&
        this.hasMore &&
        !this.loading
      ) {
        this.handleLoadMore()
        this.$nextTick(() => {
          this.checkAndAutoLoad(dropdown)
        })
      }
    },
    removeScrollListener() {
      let popperClass = this.$attrs['popper-class'] || 'search-popover'
      const dropdown = document.querySelector(
        `.${popperClass} .el-select-dropdown__wrap`
      )
      if (dropdown) {
        dropdown.removeEventListener('scroll', this.handleScroll)
        this.scrollListenerAdded = false
      }
    },
    handleScroll(e) {
      // 远程搜索时不做触底加载
      if (this.searchStuts) return
      const target = e.target
      if (target.scrollTop + target.clientHeight >= target.scrollHeight - 10) {
        this.handleLoadMore()
      }
    },
    handleLoadMore() {
      if (!this.loading && this.hasMore) {
        this.loadOptions(this.currentPage + 1, this.pageSize)
      }
    },
    handleChange(value) {
      this.internalValue = value
      this.$emit('change', value)
    },
    remoteMethod(query) {
      clearTimeout(this.searchTimer)
      if (query) {
        this.searchTimer = setTimeout(() => {
          this.searchStuts = true
          CHECKALLINDUSTRYBRAND({ value: query }).then((res) => {
            if (res.data.body && res.data.body.length > 0) {
              this.options = res.data.body.map((item) => {
                return {
                  [this.keyField]: item.code,
                  [this.labelField]: item.name,
                  [this.valueField]: item.code
                }
              })
            }
          })
        }, 300)
      } else {
        this.searchStuts = false
      }
    }
  }
}
</script>

<style scoped>
.el-select-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #7fb8f2;
  font-size: 12px;
}
.el-select-loading__tips {
  margin-left: 6px;
}
</style>
